import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AssessmentPageComponent } from './components/assessment-page/assessment-page.component';
import { CandidateFormComponent } from './components/candidate-form/candidate-form.component';
import { SubmitTestComponent } from './components/submit-test/submit-test.component';
import { testActivateGuard } from './core/guards/test.guard';
import { testDeactivateGuard } from './core/guards/test-deactivate.guard';
import { VerifyComponent } from './components/verify/verify.component';
import { CandidateDetailComponent } from './components/candidate-detail/candidate-detail.component';

const routes: Routes = [
  { 
    path: '', 
    component: CandidateFormComponent,
    canActivate: [testActivateGuard]
  },
  {
    path: 'verify/:test_code',
    component: VerifyComponent
  },
  {
    path: 'detail',
    component: CandidateDetailComponent,
    canActivate: [testActivateGuard]
  },
  {
    path: 'test', 
    component: AssessmentPageComponent, 
    canActivate: [testActivateGuard], 
    canDeactivate: [testDeactivateGuard]
  },
  {
    path: 'submit-test', 
    component: SubmitTestComponent, 
    canActivate: [testActivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
